import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

var Toaster = toast;
var SwalBox = Swal;

export {
    Toaster,
    SwalBox
};